module.exports = __webpack_public_path__ + "static/media/batman@3x.a5ee865e.png";